import { closeTimesheetModal } from '../State/timesheetModal'

export default () => (dispatch) => {

  dispatch(closeTimesheetModal())
  
}
